import React from 'react';

import {
  fixedIncomeCategoriesQuery,
  fixedIncomeProductsQuery,
} from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';

import { getFixedIncomeFilters, tableHead } from './constants';
import ProductItem from './item';

export const FixedIncomeTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={fixedIncomeProductsQuery}
      productCategoryQuery={fixedIncomeCategoriesQuery}
      productsFiltersGetter={getFixedIncomeFilters}
      tableHeadItems={tableHead}
      tabletColumns={4}
      mobileFields={[
        { key: 'customerNormalized', label: 'Cliente' },
        { key: 'issuerNormalized', label: 'Emissor' },
        { key: 'assetNormalized', label: 'Ativo' },
        { key: 'formattedIndexRateNormalized', label: 'Taxa/ind.' },
        { key: 'indexNormalized', label: 'Índice' },
        { key: 'availableQuantity', label: 'Quantidade disponível' },
        { key: 'blockedQuantityNormalized', label: 'Quantidade bloqueada' },
        { key: 'totalQuantityNormalized', label: 'Quantidade total' },
        { key: 'maturityDateNormalized', label: 'Vencimento' },
        { key: 'grossValueNormalized', label: 'Valor bruto' },
        { key: 'positionDateNormalized', label: 'Data da posição' },
        { key: 'purchaseDateNormalized', label: 'Data da compra' },
        { key: 'purchaseValueNormalized', label: 'Valor compra' },
        { key: 'iofValueNormalized', label: 'Valor IOF' },
        { key: 'irValueNormalized', label: 'Valor IR' },
        { key: 'netValueNormalized', label: 'Valor líquido' },
      ]}
    />
  );
};
